var AbstractWS = require("./AbstractWS");

function IssueTicketOverrideWS() {
  var self;

  AbstractWS.apply(this, arguments);

  self = this;
  self.method("POST");
  self.name = "IssueTicketOverrideWS"; // Convenience name for debugging
  self.queueId = ko.observable(null);

  /**
   * Defines the string to request API services
   *
   * @method serviceURL
   * @returns {String}
   */
  self.serviceURL = ko.computed(function () {
    return "/qless/api/v1/employee/queue/" + self.queueId() + "/ticket/override";
  });

  self.issueTicketForConsumer = function (sessionId, queueId, callbackFn) {
    self.queueId(queueId);
    self.addParam("queueId", queueId);
    self.addParam("sessionId", sessionId);
    self.doRequest(callbackFn);
  };

  self.issueTicketForSpot = function(spot) {
    if (spot && spot.sessionId && spot.queueId) {
      self.issueTicketForConsumer(spot.sessionId, spot.queueId); 
    }
  }

  self.reset = function() {
    IssueTicketOverrideWS.prototype.reset.apply(self)
    self.queueId(null);
  }

  return self;
}

IssueTicketOverrideWS.prototype = Object.create(AbstractWS.prototype);
IssueTicketOverrideWS.prototype.constructor = IssueTicketOverrideWS;

module.exports = IssueTicketOverrideWS;
